(function (angular) {
	'use strict';

	angular
		.module('questionnaireModule')
		.controller('Questionnaire', [
			'$cookies',
			'$timeout',
			'$window',
			'localStorageFactory',
			'urlFactory',
			QuestionnaireFunction
		]);

	function QuestionnaireFunction(
		$cookies,
		$timeout,
		$window,
		localStorageFactory,
		urlFactory) {
		
		var questionnaire = this;
		
		var questionnaireServiceLevelLocalStorage = 'com.fundrise.questionnaire.recommendedServiceLevel';
		var questionnairePlanLocalStorage = 'com.fundrise.questionnaire.recommendedPlan';

		questionnaire.currentStep = 1;
		questionnaire.retirementOptions = ['retired', 'not retired'];
		questionnaire.retired = questionnaire.retirementOptions[1];
		
		if (urlFactory.getUrlParam('skipFirstStep')) {
			questionnaire.currentStep = 2;
			questionnaire.age = parseInt(urlFactory.getUrlParam('age'));
			questionnaire.retired = urlFactory.getUrlParam('retired');
			questionnaire.realEstateExperience = urlFactory.getUrlParam('realEstateExperience');
		}

		questionnaire.complete = function() {
			scorePlan();
			scoreServiceLevel();
			questionnaire.recommendedGoal = localStorageFactory.getItem(questionnairePlanLocalStorage);

			var urlSlug = '/confirm-goal?goalName=' + questionnaire.recommendedGoal + '&timeHorizon=' + questionnaire.timeHorizon;

			if (questionnaire.investmentAmount !== undefined && questionnaire.investmentAmount !== 0) {
				urlSlug += '&investmentAmount=' + questionnaire.investmentAmount;
			} else if (questionnaire.investableAssets) {
				questionnaire.investmentAmount = questionnaire.investableAssets * 0.2;

				urlSlug += '&investmentAmount=' + questionnaire.investmentAmount;
			}

			setMixpanelPropertiesAndRedirect(urlSlug);
		};
		
		questionnaire.assessInvestmentAmountValidity = function(){
			var investmentAmount = parseInt(questionnaire.investmentAmount);
			
			if (investmentAmount >= 500 && investmentAmount <= 250000) {
				questionnaire.step4.investmentAmount.$setValidity('amount', true);
			} else {
				questionnaire.step4.investmentAmount.$setValidity('amount', false);
			}
		};

		questionnaire.advance = function() {
			if (questionnaire.currentStep === 4) {
				questionnaire.complete();
			} else {
				questionnaire.currentStep += 1;
			}

			if ($window.mixpanel){
				$window.mixpanel.track('Questionnaire Step Viewed', {
					'Step' : questionnaire.currentStep
				});
			}
		};

		questionnaire.back = function() {
			if (questionnaire.currentStep === 1) {
				urlFactory.redirect('/start-investing');
			} else if(questionnaire.currentStep === 2 && urlFactory.getUrlParam('skipFirstStep')) {
				urlFactory.redirect('/start-investing');
			} else {
				questionnaire.currentStep -= 1;
			}
		};

		function scorePlan() {
			if (questionnaire.investmentAmount < 1000) {
				localStorageFactory.setItem(questionnairePlanLocalStorage, 'Starter Portfolio');
			} else if (questionnaire.indicatedGoal === 'INCOME') {
				if (questionnaire.timeHorizon < 10) {
					localStorageFactory.setItem(questionnairePlanLocalStorage, 'Supplemental Income');
				} else {
					localStorageFactory.setItem(questionnairePlanLocalStorage, 'Balanced Investing');
				}
			} else {
				if (questionnaire.timeHorizon <= 10) {
					localStorageFactory.setItem(questionnairePlanLocalStorage, 'Balanced Investing');
				} else {
					localStorageFactory.setItem(questionnairePlanLocalStorage, 'Long-Term Growth');
				}
			}
		}

		function scoreServiceLevel() {
			if (questionnaire.investmentAmount < 1000) {
				localStorageFactory.setItem(questionnaireServiceLevelLocalStorage, 'Starter');
			} else if (questionnaire.investmentAmount >= 1000 && questionnaire.investmentAmount < 10000) {
				localStorageFactory.setItem(questionnaireServiceLevelLocalStorage, 'Core');
			} else {
				localStorageFactory.setItem(questionnaireServiceLevelLocalStorage, 'Advanced');
			}
		}
		
		function setMixpanelPropertiesAndRedirect(urlSlug){
			var mixpanelTrackingObj = {
				'Year of Birth': new Date().getFullYear() - questionnaire.age,
				'Indicated Goal': questionnaire.indicatedGoal,
				'Time Horizon': questionnaire.timeHorizon,
				'Investment Amount': questionnaire.investmentAmount,
				'Retired': questionnaire.retired,
				'Recommended Goal' : questionnaire.recommendedGoal
			};
			
			var mixpanelPeopleObj = {
				'Year of Birth [RIA Questionnaire]': new Date().getFullYear() - questionnaire.age,
				'Indicated Goal [RIA Questionnaire]': questionnaire.indicatedGoal,
				'Time Horizon [RIA Questionnaire]': questionnaire.timeHorizon,
				'Investment Amount [RIA Questionnaire]': questionnaire.investmentAmount,
				'Retired [RIA Questionnaire]': questionnaire.retired
			};
			
			if (angular.isDefined(questionnaire.realEstateExperience)) {
				mixpanelTrackingObj['Real Estate Experience'] = questionnaire.realEstateExperience;
				mixpanelPeopleObj['Real Estate Experience [RIA Questionnaire]'] = questionnaire.realEstateExperience;
			}
			
			if ($window.mixpanel) {
				
				if($window.mixpanel.get_distinct_id && $cookies.get('lead.capture') === $window.mixpanel.get_distinct_id()) {
					$window.mixpanel.identify();
				}
				
				$window.mixpanel.people.set(mixpanelPeopleObj);

				$window.mixpanel.track('RIA Questionnaire Submitted', mixpanelTrackingObj);
				$timeout(function() {
					urlFactory.redirect(urlSlug);
				}, 200);
			}
		}
	}
})(window.angular);